import React, { ReactElement, Ref } from 'react';

import MultiDropdownTokenControl from './MultiDropdownTokenControl';
import { ControlProps } from '../layout';
import ControlLabel from '../layout/Control/ControlLabel';
import { GenericItem } from '../types';

type SingleDropdownTokenControlProps<TItem extends GenericItem> =
  ControlProps<TItem> & {
    selectItem: (item: TItem) => void;
  };

const SingleDropdownTokenControlWrapped = <TItem extends GenericItem>(
  {
    selectItem,
    selectedItem,
    ...props
  }: SingleDropdownTokenControlProps<TItem>,
  ref: Ref<HTMLDivElement | HTMLLabelElement>,
) => (
  <MultiDropdownTokenControl
    ref={ref}
    getSelectedItemProps={() => ({})}
    removeSelectedItem={() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore https://github.com/downshift-js/downshift/pull/1334
      selectItem(null);
    }}
    selectedItems={selectedItem ? [selectedItem] : null}
    {...props}
  />
);

const SingleDropdownTokenControl = React.forwardRef(
  SingleDropdownTokenControlWrapped,
);

SingleDropdownTokenControl.displayName = 'SingleDropdownTokenControl';

SingleDropdownTokenControl.propTypes = {
  ...ControlLabel.propTypes,
};

export default SingleDropdownTokenControl as <T extends GenericItem>(
  p: SingleDropdownTokenControlProps<T> & {
    ref?: Ref<HTMLDivElement | HTMLLabelElement>;
  },
) => ReactElement;
